module.exports = __webpack_public_path__ + "static/img/7en.2938928.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/rongyao/7en.png
// module id = BPpE
// module chunks = 0